// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import PersonalDetailsActionType from './personal-details.types';

const INITIAL_STATE = {
	// Personal details response
	personalDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Personal Details Add Start ************************/
		case PersonalDetailsActionType.PERSONAL_DETAILS_SUCCESS:
			return { ...state, personalDetailsResponse: action.payload };

		case PersonalDetailsActionType.PERSONAL_DETAILS_FAILURE:
			return { ...state, personalDetailsResponse: action.payload };

		case PersonalDetailsActionType.PERSONAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, personalDetailsResponse: null };

		/** ***************** Personal Details Add End ************************/
		default:
			return state;
	}
};
